<button class="map-legend-button material-icons map-legend-button--colorized"
    [ngClass]="{'disabled': disabled}"
    [anatomicMapTooltip]="buttonConfig?.tooltipDescription ? (getTranslationLabel(buttonConfig?.btnType) | translate: {p0: buttonConfig?.tooltipDescription!}) : '' "
    [disabled]="disabled"
    (click)="onButtonClick()">
    <div class="button-icon">
        {{ buttonConfig?.btnType === 'type2' ? 'check_box': 'library_add_check'  }}
    </div>
    <div class="button-shadow" [style]="'color:' + buttonConfig?.color"></div>
</button>
